const styles = {
  outerBox: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    alignItems: 'center',
    overflow: 'hidden',
  },
  image: {
    display: 'block',
    width: '100%',
    height: 'auto',
    maxWidth: '140px',
    padding: '5px 15px',
    margin: '10px auto',
    filter: 'grayscale(100%)',
  },
};

export default styles;
